import { useDispatch, useSelector } from "react-redux"
import { addToCart } from "../../Redux/Slices/cartSlice"
import { fa_currency, fa_number } from "../../utils/PersianNum";
import RelatedProduct from "./RelatedProduct";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import parse from 'html-react-parser';
import { useState } from "react";

// import Ratings from "react-ratings-declarative";
// import { Link } from "react-router-dom";

// const iconPath =
//   "M18.571 7.221c0 0.201-0.145 0.391-0.29 0.536l-4.051 3.951 0.96 5.58c0.011 0.078 0.011 0.145 0.011 0.223 0 0.29-0.134 0.558-0.458 0.558-0.156 0-0.313-0.056-0.446-0.134l-5.011-2.634-5.011 2.634c-0.145 0.078-0.29 0.134-0.446 0.134-0.324 0-0.469-0.268-0.469-0.558 0-0.078 0.011-0.145 0.022-0.223l0.96-5.58-4.063-3.951c-0.134-0.145-0.279-0.335-0.279-0.536 0-0.335 0.346-0.469 0.625-0.513l5.603-0.815 2.511-5.078c0.1-0.212 0.29-0.458 0.547-0.458s0.446 0.246 0.547 0.458l2.511 5.078 5.603 0.815c0.268 0.045 0.625 0.179 0.625 0.513z";

function Product({data,showCart}) {
    const dispatch = useDispatch();
    const [quantity, setQuantity] = useState(1);

    const handleAddToCart = () => {
        dispatch(addToCart({ product: data, quantity: Number(quantity) }));
    };

    const cart = useSelector((state) => state.cart.cart);
    const totalItems = cart.reduce((total, product) => total + product.quantity, 0);

    // function changeRating(newRating) {}

    return (
        <div className="container mt-5 py-4 px-xl-3">
        <div className="row mb-4">
            {/* <div className="d-none d-lg-block col-lg-1">
                <div className="image-vertical-scroller">
                    <div className="d-flex flex-column">
                    {Array.from({ length: 10 }, (_, i) => {
                        let selected = i !== 1 ? "opacity-6" : "";
                        return (
                        <a key={i} href="!#">
                            <img
                            className={"rounded mb-2 ratio " + selected}
                            alt=""
                            src={Image}
                            />
                        </a>
                        );
                    })}
                    </div>
                </div>
            </div> */}
            <div className="col-lg-6">
                <div className="row">
                    <div className="col-12 mb-4">
                    <Zoom>
                    <img
                        className="border rounded ratio ratio-1x1"
                        alt="product"
                        src={data.images}
                    />
                    </Zoom>
                    </div>
                </div>

                {/* <div className="row mt-2">
                    <div className="col-12">
                    <div
                        className="d-flex flex-nowrap"
                        style={{ overflowX: "scroll" }}
                    >
                        {Array.from({ length: 8 }, (_, i) => {
                        return (
                            <a key={i} href="!#">
                            <img
                                className="cover rounded mb-2 me-2"
                                width="70"
                                height="70"
                                alt=""
                                src={Image}
                            />
                            </a>
                        );
                        })}
                    </div>
                    </div>
                </div> */}
            </div>

            <div className="col-lg-6">
                <div className="d-flex flex-column h-100">
                    <h2 className="mb-1">{data.name}</h2>
                    {data.price === '0' ? <h5 className="text-muted mb-4">تماس بگیرید</h5> :
                    data.sale_price && data.sale_price > 0 ?
                        <h4 className="text-muted mb-4"><del>{fa_currency(+data.price)}</del> {fa_currency(+data.sale_price)}تومان</h4>
                        :
                        <h4 className="text-muted mb-4">{fa_currency(+data.price)} تومان</h4>
                    }

                    <div className="row g-3 mb-4">
                        <div className="col-1 p-0">
                            <input className="form-control text-center" id="inputQuantity" type="number" onChange={(e) => setQuantity(e.target.value)} min={1} value={quantity} style={{maxWidth: "6rem"}} />
                        </div>
                        <div className="col">
                            <button className="btn btn-outline-dark w-100" onClick={handleAddToCart} disabled={data.price === '0'}>
                                اضافه به سبد
                            </button>
                        </div>
                        <div className="col">
                            <button className="btn btn-dark w-100" type="button" onClick={() => showCart(true)}>مشاهده سبد خرید<span className="badge ms-2">{fa_number(+totalItems)}</span></button>
                        </div>
                    </div>

                    <h4 className="mb-0">جزئیات محصول</h4>
                    <hr />
                    <dl className="row">
                    
                    <dt className="col-sm-4">معرفی محصول</dt>
                    <dd className="col-sm-8 mb-3">{data.detail}</dd>

                    <dt className="col-sm-4">دسته بندی</dt>
                    <dd className="col-sm-8 mb-3">{data.ProductCategory.name}</dd>

                    <dt className="col-sm-4">شناسه محصول</dt>
                    <dd className="col-sm-8 mb-3">{data.sku ? data.sku : '-'}</dd>

                    <dt className="col-sm-4">موجودی</dt>
                    <dd className="col-sm-8 mb-3">{data.quantity > 0 ? `${fa_number(data.quantity)} موجودی انبار` : "عدم موجودی"}</dd>
                    
                    </dl>

                    <h4 className="mb-0">توضیحات محصول</h4>
                    <hr />
                    <div className="lead flex-shrink-0">
                    <small>
                        {parse(data.description)}
                    </small>
                    </div>
                </div>
            </div>
        </div>

            {data.ProductCategory.Products && data.ProductCategory.Products.length > 0 &&
            <div className="row">
                <div className="col-md-12 mb-4">
                    <hr />
                    <h4 className="text-muted my-4">سایر محصولات دسته</h4>
                    <div className="row row-cols-1 row-cols-md-3 row-cols-lg-4 g-3">
                        {data.ProductCategory.Products.map((v, i) => 
                            <RelatedProduct key={i} prod={v} />
                        )}
                    </div>
                </div>
            </div>}
            
        </div>
    );
}

export default Product;
